import AboutPageAboutUs from './components/AboutPageAboutUs';
import AboutPageDetails from './components/AboutPageDetails';
import AboutPageHeader from './components/AboutPageHeader';
import AboutPageHowToUse from './components/AboutPageHowToUse';
import background from '@/assets/about-us.jpg';
import HomePageTestimonials from '@/pages/Home/components/HomePageTestimonials.jsx';
import Layout from '@/components/Layout/Layout.jsx';

const AboutPage = () => {
  return (
    <Layout>
      <AboutPageHeader />
      <AboutPageAboutUs />
      <AboutPageDetails />
      <AboutPageHowToUse />
      <div className='h-96 w-full bg-cover bg-fixed bg-top' style={{ backgroundImage: `url(${background})` }}></div>
      <HomePageTestimonials />
    </Layout>
  );
};

export default AboutPage;
